module.exports = __webpack_public_path__ + "static/columbus-fde865cb6a7184a1a6bdc445f41ed82d.png";